import as2IdReducer from '../as2Id';
import undoable, { includeAction } from 'redux-undo';
import { UPDATE_AS2ID, ADD_AS2ID, DELETE_AS2ID } from '../../As2IdActionTypes';

const undoableAs2Id = undoable(as2IdReducer, {
  filter: includeAction([UPDATE_AS2ID, ADD_AS2ID, DELETE_AS2ID]),
});

export default undoableAs2Id;
